import { render, staticRenderFns } from "./chronicle_barchart.vue?vue&type=template&id=87f7fff8&scoped=true"
import script from "./chronicle_barchart.vue?vue&type=script&lang=js"
export * from "./chronicle_barchart.vue?vue&type=script&lang=js"
import style0 from "./chronicle_barchart.vue?vue&type=style&index=0&id=87f7fff8&prod&lang=css"
import style1 from "./chronicle_barchart.vue?vue&type=style&index=1&id=87f7fff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f7fff8",
  null
  
)

export default component.exports